export enum ConstructionAgreementEnum {
  FIXED_PRICE_CONTRACT = 'FixedPriceContract',
  MANAGEMENT_CONTRACT = 'ManagementContract',
  GUARANTEED_MAXIMUM_PRICE = 'GuaranteedMaximumPrice',
  OTHER = 'Other',
}
